import { render, staticRenderFns } from "./create-subject.view.vue?vue&type=template&id=343dde46&"
import script from "./create-subject.view.ts?vue&type=script&lang=ts&"
export * from "./create-subject.view.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports